import React, { useState } from "react";
import SeccionCard from "../SeccionCard";

/**
 * Recetas / Certificados: sección de una línea, con contador y botón que
 * despliega el formulario que ya existe (modal). Nunca cuenta para el avance,
 * nunca bloquea. Cuando hay elementos, se listan debajo.
 */
export default function SeccionColapsable({
  seccionId,
  items = [],
  columnas, // [{key,label}]
  render, // (item) => cells
  textoAgregar,
  bloqueado,
  onAgregar,
  onAccion, // (item) => void  (imprimir/ver) — por fila
  textoAccion = "Ver",
  accionCabecera, // { label, onClick } — acción del conjunto (p. ej. imprimir la receta de la cita)
  onNavegar,
}) {
  const [abierto, setAbierto] = useState(items.length > 0);

  return (
    <SeccionCard
      seccionId={seccionId}
      headerExtra={<span className="cev__tag cev__tag--grey">{items.length}</span>}
      onNavegar={onNavegar}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <button type="button" className="cev__btn cev__btn--sm" onClick={() => setAbierto((v) => !v)}>
          {abierto ? "Ocultar" : "Mostrar"} ({items.length})
        </button>
        {accionCabecera && items.length > 0 && (
          <button type="button" className="cev__btn cev__btn--sm" onClick={accionCabecera.onClick}>
            {accionCabecera.label}
          </button>
        )}
        <button type="button" className="cev__btn cev__btn--pri cev__btn--sm" disabled={bloqueado} onClick={onAgregar}>
          {textoAgregar}
        </button>
      </div>

      {abierto && (
        items.length === 0 ? (
          <div className="cev__empty">Nada emitido en esta consulta.</div>
        ) : (
          <table className="cev__list" style={{ marginTop: 10 }}>
            <thead>
              <tr>
                {columnas.map((c) => (
                  <th key={c.key}>{c.label}</th>
                ))}
                <th aria-label="Acción" />
              </tr>
            </thead>
            <tbody>
              {items.map((it, i) => (
                <tr key={i}>
                  {render(it)}
                  <td>
                    {onAccion && (
                      <button type="button" className="cev__btn cev__btn--ghost cev__btn--sm" onClick={() => onAccion(it)}>
                        {textoAccion}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )
      )}
    </SeccionCard>
  );
}
